import { render, staticRenderFns } from "./PlanDetail.vue?vue&type=template&id=cf155eaa&scoped=true"
import script from "./PlanDetail.vue?vue&type=script&lang=js"
export * from "./PlanDetail.vue?vue&type=script&lang=js"
import style0 from "./PlanDetail.vue?vue&type=style&index=0&id=cf155eaa&prod&lang=css"
import style1 from "./PlanDetail.vue?vue&type=style&index=1&id=cf155eaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf155eaa",
  null
  
)

export default component.exports